/* TypeScript file generated from Popover.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as PopoverJS from './Popover.res.js';

import type {Overlay_Position_placement as ReactAria_Overlay_Position_placement} from '../../../src/externals/ReactAria.gen';

import type {Overlay_Trigger_state as ReactStately_Overlay_Trigger_state} from '../../../src/externals/ReactStately.gen';

import type {Popover_ariaProps as ReactAria_Popover_ariaProps} from '../../../src/externals/ReactAria.gen';

import type {animation as AnimatedRender_animation} from '../../../src/primitives/AnimatedRender.gen';

export type t = ReactStately_Overlay_Trigger_state;

export type layout = 
    "auto"
  | "triggerMinWidth"
  | "triggerStrictWidth";

export type variation = "normal" | "arrowed";

export type size = "normal" | "compact";

export type props<children,ariaProps,popoverRef,triggerRef,state,variation,borderColor,size,placement,layout,animation,overlayPriority,dismissable,shouldUpdatePosition,modal,offset,crossOffset> = {
  readonly children: children; 
  readonly ariaProps?: ariaProps; 
  readonly popoverRef?: popoverRef; 
  readonly triggerRef: triggerRef; 
  readonly state: state; 
  readonly variation?: variation; 
  readonly borderColor?: borderColor; 
  readonly size?: size; 
  readonly placement?: placement; 
  readonly layout?: layout; 
  readonly animation?: animation; 
  readonly overlayPriority?: overlayPriority; 
  readonly dismissable?: dismissable; 
  readonly shouldUpdatePosition?: shouldUpdatePosition; 
  readonly modal?: modal; 
  readonly offset?: offset; 
  readonly crossOffset?: crossOffset
};

export const make: React.ComponentType<{
  readonly children: React.ReactNode; 
  readonly ariaProps?: ReactAria_Popover_ariaProps; 
  readonly popoverRef?: any; 
  readonly triggerRef: any; 
  readonly state: t; 
  readonly variation?: variation; 
  readonly borderColor?: string; 
  readonly size?: size; 
  readonly placement?: ReactAria_Overlay_Position_placement; 
  readonly layout?: layout; 
  readonly animation?: AnimatedRender_animation; 
  readonly overlayPriority?: boolean; 
  readonly dismissable?: boolean; 
  readonly shouldUpdatePosition?: boolean; 
  readonly modal?: boolean; 
  readonly offset?: number; 
  readonly crossOffset?: number
}> = PopoverJS.make as any;
